__turbopack_context__.v({
  "root": "InlineFilters-Section-module-scss-module__9yg7zq__root",
  "target": "InlineFilters-Section-module-scss-module__9yg7zq__target",
});
